import { call, put, takeLatest } from 'redux-saga/effects'
import { BookingActions, BookingTypes } from './bookingSlice'
import api from '../../services/api'

function* createBookingSaga(action) {
    const { data } = action
    const response = yield call(api.createBooking, data)

    if (response.ok) {
        yield put(BookingActions.createBookingSuccess(response.data))
    } else {
        yield put(BookingActions.createBookingFailure(response.problem))
    }
}

function* getMyBookings(action) {
    const { options } = action;
    const response = yield call(api.getMyBookings, options)

    if (response.ok) {
        yield put(BookingActions.fetchingMyBookingSuccess(response.data))
    } else {
        yield put(BookingActions.fetchingMyBookingFailure(response.problem))
    }
}

function* getMyAppointment(action) {
    const { options } = action;
    const response = yield call(api.getMyAppointments, options)

    if (response.ok) {
        yield put(BookingActions.fetchingMyAppointmentSuccess(response.data))
    } else {
        yield put(BookingActions.fetchingMyAppointmentFailure(response.problem))
    }
}

function* confirmBooking(action) {
    const { bookingId } = action;
    const response = yield call(api.confirmBooking, bookingId)

    if (response.ok) {
        yield put(BookingActions.confirmBookingSuccess(response.data))
    } else {
        const errorMsg = response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem
        yield put(BookingActions.confirmBookingFailure(errorMsg))
    }

}

function* cancelBooking(action) {
    const { bookingId } = action;
    const response = yield call(api.cancelBooking, bookingId)

    if (response.ok) {
        yield put(BookingActions.cancelBookingSuccess(response.data))
    } else {
        const errorMsg = response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem
        yield put(BookingActions.cancelBookingFailure(errorMsg))
    }

}


export default function* bookingSaga() {
    yield takeLatest(BookingTypes.CREATE_BOOKING_REQUEST, createBookingSaga),
        yield takeLatest(BookingTypes.FETCHING_MY_BOOKING_REQUEST, getMyBookings),
        yield takeLatest(BookingTypes.FETCHING_MY_APPOINTMENT_REQUEST, getMyAppointment),
        yield takeLatest(BookingTypes.CONFIRMING_BOOKING_REQUEST, confirmBooking),
        yield takeLatest(BookingTypes.CANCELLING_BOOKING_REQUEST, cancelBooking)

}